import { IOffer as IOffer, OfferCardWidgetContainer as OfferCardWidget } from '../../../../../packages/OfferCardWidget';
import { useSelector } from 'react-redux';
import { selectOffers } from 'shared/selectors/offers';
import { selectUser } from 'shared/selectors/user';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { selectHouseId } from 'shared/selectors/houseInfo';
import {
  trackChatButtonClick,
  trackChatPopupOpen,
  trackComparisonChange,
  trackFavoritesChange,
  trackOfferCardClick,
  trackPhoneShow,
} from '../../tracking';
import { useEventCallback } from '@cian/react-utils';

export const OffersContainerDesktop = () => {
  const context = useApplicationContext();
  const user = useSelector(selectUser);
  const offers = useSelector(selectOffers) as IOffer[];
  const houseId = useSelector(selectHouseId);

  const getOfferTracking = useEventCallback((offer: IOffer, index: number) => {
    const commonProps = {
      offerId: offer.id,
      position: index + 1,
      houseId,
      label: offer.gaLabel ?? /* istanbul ignore next */ '',
    };
    const ownerId = offer.user?.cianUserId;

    return {
      onCardClick: trackOfferCardClick,
      onPhoneShow: () => trackPhoneShow(commonProps),
      onChatButtonClick: () => trackChatButtonClick({ ...commonProps, ownerId }),
      onChatPopupOpen: () => trackChatPopupOpen({ ...commonProps, ownerId }),
      onFavoritesAdd: () => trackFavoritesChange({ ...commonProps, isAdded: true }),
      onFavoritesRemove: () => trackFavoritesChange({ ...commonProps, isAdded: false }),
      onComparisonAdd: () => trackComparisonChange({ ...commonProps, isAdded: true }),
      onComparisonRemove: () => trackComparisonChange({ ...commonProps, isAdded: false }),
    };
  });

  return (
    <div>
      {offers.map((offer, index) => (
        <OfferCardWidget
          key={offer.id}
          offer={offer}
          user={user}
          context={context}
          {...getOfferTracking(offer, index)}
        />
      ))}
    </div>
  );
};
